import { createAsyncThunk } from '@reduxjs/toolkit';
import { PlaidApi } from 'api/PlaidApi';

export interface BankAccountParam {
  applicationId: string;
  plaidPublicToken?: string;
}

export const createGetCheckingAccounts = (api: PlaidApi) =>
  createAsyncThunk('getCheckingAccounts', async (payload: BankAccountParam) => {
    const { applicationId } = payload;
    const checkingAccounts = await api.getCheckingAccounts(applicationId);
    return checkingAccounts;
  });

export default createGetCheckingAccounts;
